import { render, staticRenderFns } from "./QuizActionModal.vue?vue&type=template&id=28d082c1&scoped=true&"
import script from "./QuizActionModal.vue?vue&type=script&lang=js&"
export * from "./QuizActionModal.vue?vue&type=script&lang=js&"
import style0 from "./QuizActionModal.vue?vue&type=style&index=0&id=28d082c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d082c1",
  null
  
)

export default component.exports